/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import CustomerSubscriptionRoutes from './customer-subscription.routes';
import CustomerSubscriptionDirective from './customer-subscription.directive';
import CustomerSubscriptionTableConfig from './customer-subscription-table.config';

export default angular.module('tektelic.customerSubscription', [])
    .config(CustomerSubscriptionRoutes)
    .directive('tkCustomerSubscription', CustomerSubscriptionDirective)
    .factory('customerSubscriptionTableConfig', CustomerSubscriptionTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/customer/subscription/index.js